export const BRAND_MENTION_PLATFORMS = [
	'x',
	'reddit',
	'facebook',
	'linkedin',
	'youtube',
] as const

export type BrandMentionPlatform = (typeof BRAND_MENTION_PLATFORMS)[number]

export const PLATFORM_LABELS: Record<BrandMentionPlatform, string> = {
	x: 'X',
	reddit: 'Reddit',
	facebook: 'Facebook',
	linkedin: 'LinkedIn',
	youtube: 'YouTube',
}

export const BRAND_MENTION_ADDON_PLATFORMS: BrandMentionPlatform[] = [
	...BRAND_MENTION_PLATFORMS,
]

export const BRAND_MENTION_ADDON_PRICE_MONTHLY = 25

export interface BrandMention {
	id: string
	platform: BrandMentionPlatform
	title: string
	text: string
	url: string
	author: string
	publishedAt: string
	kind: string
	domainMatch: boolean
}

export interface BrandMentionJob {
	id: string
	platform: BrandMentionPlatform
	endpoint: string
	params: Record<string, string>
	cursor?: string
	seen: string[]
	seenRows?: string[]
	pages: number
	done: boolean
	error?: string
}

export interface BrandMentionRun {
	version: number
	mode?: string
	brandName: string
	brandDomain: string
	startedAt?: string
	previousSearchAt?: string
	history?: { start: string; end: string; incomplete: string[] }[]
	start: string
	end: string
	label: string
	jobs: BrandMentionJob[]
	chargedMicro: number
	reservedMicro: number
	calls: { id: string; endpoint: string; costMicro: number | null; chargedAt?: string }[]
	updatedAt: string
	excludedUndated: number
	pending: boolean
	budgetStopped: boolean
}

export interface BrandMentionsState {
	configured: boolean
	enabled?: boolean
	needsWebsiteUrl: boolean
	websiteUrl: string
	brandName: string | null
	brandDomain: string | null
	planId?: string
	platforms?: BrandMentionPlatform[]
	addonEnabled?: boolean
	upgradeRequired?: boolean
	addonRequired?: boolean
	maxMentionsPerDay?: number
	shouldScan?: boolean
	nextSearchAt?: string | null
	lastSearchedAt?: string | null
	run: BrandMentionRun | null
	mentions: BrandMention[]
	total: number
	error?: string
}
